import { Swiper, SwiperSlide } from "swiper/react";
import { SlideBulletNavigation } from "../../../../../components/blog/RelatedPosts/SlideBulletNavigation";
import { Line } from "../../components/Line";
import { Subtitle } from "../../components/Subtitle";
import { Text } from "../../components/Text";
import "swiper/css";
import styled from "styled-components";
import { device, size } from "../../../../../constants";
import { useState } from "react";
import { SlideArrowNavigation } from "../../../../../components/blog/RelatedPosts/SlideArrowNavigation";
import { cn } from "../../../../../lib/utils";
import { useTranslation } from "next-i18next";

const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
	.arrows {
		display: none;

		button:disabled {
			background-color: transparent;
			border-color: #fff;

			svg path {
				color: #fff;

				:is([data-theme="dark"] &) {
					color: #fff;
				}
			}
		}
	}
	
  @media ${device.laptop} {
		justify-content: space-between;
    align-items: flex-start;
		
		.bullets {
			display: none;
		}

    .arrows {
      display: block;
			margin-left: auto;
    }
  }
`;

const SwiperWrapper = styled.div`
  .bullets-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bullet {
    background-color: #fff;
    opacity: 0.5;
  }
  
  .bullet-active {
    opacity: 1;
  }

  :is([data-theme="dark"] &) {
    .bullet {
      background-color: #fff;
    }
  }

	.swiper-slide:last-child > div {
		border-right: none;
	}
`;

function ResultCard({ result }) {
	return (
		<div
			className={cn(
				"px-4 py-4 flex flex-col justify-center items-center mx-auto border-r-0 border-r-white",
				[
					"laptop:px-6 laptop:pl-0 laptop:max-w-none laptop:mx-0 laptop:border-r-[3px]",
				],
			)}
		>
			<span
				className={cn(
					"max-w-[310px] font-bold h-[64px] text-[72px] text-white inline-flex items-center justify-center",
					["laptop:max-w-[272px] laptop:text-[70px] laptop:h-[80px]"],
				)}
			>
				{result.number}
			</span>
			<span
				className={cn(
					"max-w-[310px] text-[32px] font-bold text-white mt-4 h-[48px] inline-flex items-center justify-center",
					["laptop:max-w-[272px] laptop:mt-2"],
				)}
			>
				{result.description}
			</span>
			<p
				className={cn(
					"max-w-[310px] text-base leading-7 text-white mt-4 text-center",
					["laptop:max-w-[272px] laptop:text-lg"],
				)}
			>
				{result.content}
			</p>
		</div>
	);
}

export default function ResultsSection() {
	const { t } = useTranslation();
	const [activeBullet, setActiveBullet] = useState(0);

	const results = [
		{
			number: t("products.zignet.results.metrics.productivity.number"),
			description: t("products.zignet.results.metrics.productivity.description"),
			content: t("products.zignet.results.metrics.productivity.content"),
		},
		{
			number: t("products.zignet.results.metrics.cost.number"),
			description: t("products.zignet.results.metrics.cost.description"),
			content: t("products.zignet.results.metrics.cost.content"),
		},
		{
			number: t("products.zignet.results.metrics.accuracy.number"),
			description: t("products.zignet.results.metrics.accuracy.description"),
			content: t("products.zignet.results.metrics.accuracy.content"),
		},
		{
			number: t("products.zignet.results.metrics.queries.number"),
			description: t("products.zignet.results.metrics.queries.description"),
			content: t("products.zignet.results.metrics.queries.content"),
		},
		{
			number: t("products.zignet.results.metrics.delivery.number"),
			description: t("products.zignet.results.metrics.delivery.description"),
			content: t("products.zignet.results.metrics.delivery.content"),
		},
		{
			number: t("products.zignet.results.metrics.production.number"),
			description: t("products.zignet.results.metrics.production.description"),
			content: t("products.zignet.results.metrics.production.content"),
		},
	];

	return (
		<section className="bg-[#005EAD]">
			<div className="container-blog">
				<div className="flex flex-col items-center mb-6 laptop:mb-14">
					<Line />

					<Subtitle>
						<h3>{t("products.zignet.results.title")}</h3>
					</Subtitle>

					<Text className="text-center max-w-[298px] laptop:max-w-none">
						{t("products.zignet.results.description")}
					</Text>
				</div>

				<SwiperWrapper>
					<Swiper
						slidesPerView={1}
						navigation={false}
						spaceBetween={24}
						breakpoints={{
							[size.tablet]: {
								slidesPerView: 2,
							},
							[size.laptopL]: {
								slidesPerView: 4,
							},
						}}
						onSlideChange={(e) => {
							setActiveBullet(e.activeIndex);
						}}
					>
						{results.map((result) => (
							<SwiperSlide key={result.description}>
								<ResultCard result={result} />
							</SwiperSlide>
						))}

						<NavigationContainer className="mt-6">
							<div className="bullets">
								<SlideBulletNavigation activeBullet={activeBullet} />
							</div>
							<div className="arrows">
								<SlideArrowNavigation />
							</div>
						</NavigationContainer>
					</Swiper>
				</SwiperWrapper>
			</div>
		</section>
	);
}
